document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-nav');
  if (button && nav) button.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? 'CLOSE' : 'MENU';
  });

  document.querySelectorAll('.hero-media').forEach((media) => {
    const slides = [...media.querySelectorAll('.hero-slide')];
    if (slides.length < 2) return;
    let current = 0;
    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 5000);
  });
});

class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-carousel-thumb]')];
    this.activeIndex = 0;
    this.querySelectorAll('[data-dir]').forEach((button) => button.addEventListener('click', () => this.move(button.dataset.dir === 'next' ? 1 : -1)));
    this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.goTo(index)));
    const initialId = this.dataset.initialMediaId;
    const initialIndex = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(initialId));
    this.goTo(initialIndex >= 0 ? initialIndex : 0, false);
  }

  move(step) { this.goTo((this.activeIndex + step + this.slides.length) % this.slides.length); }

  goTo(index, smooth = true) {
    if (!this.track || !this.slides[index]) return;
    this.activeIndex = index;
    this.track.scrollTo({ left: this.track.clientWidth * index, behavior: smooth ? 'smooth' : 'auto' });
    this.thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false'));
  }

  goToMedia(mediaId) {
    const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
    if (index >= 0) this.goTo(index);
  }
}

if (!customElements.get('product-carousel')) customElements.define('product-carousel', ProductCarousel);

function formatShopifyMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

function updateProductForm(form) {
  const selects = [...form.querySelectorAll('[data-variant-select]')];
  const variantData = form.querySelector('[data-product-variants]');
  if (!variantData) return;
  const values = selects.map((select) => select.value);
  const variants = JSON.parse(variantData.textContent);
  const variant = variants.find((candidate) => candidate.options.every((option, index) => option === values[index]));
  const submit = form.querySelector('[name="add"]');

  if (!variant) {
    if (submit) { submit.disabled = true; submit.textContent = 'UNAVAILABLE'; }
    return;
  }

  form.querySelector('[name="id"]').value = variant.id;
  const section = form.closest('.main-product-section');
  const price = section.querySelector('[data-variant-price]');
  const compare = section.querySelector('[data-variant-compare]');
  if (price) price.textContent = formatShopifyMoney(variant.price);
  if (compare) {
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    compare.hidden = !onSale;
    compare.textContent = onSale ? formatShopifyMoney(variant.compare_at_price) : '';
  }
  if (submit) {
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'ADD TO CART →' : 'SOLD OUT';
  }

  selects.forEach((select) => {
    const field = select.closest('[data-option-index]');
    const label = field?.querySelector('[data-selected-option]');
    if (label) label.textContent = select.value;
    field?.querySelectorAll('[data-swatch-value]').forEach((choice) => {
      const selected = choice.dataset.swatchValue === select.value;
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-pressed', String(selected));
    });
  });

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());
  const carousel = section.querySelector('product-carousel');
  if (variant.featured_media?.id) carousel?.goToMedia(variant.featured_media.id);
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (select) updateProductForm(select.closest('form'));
});

document.addEventListener('click', (event) => {
  const choice = event.target.closest('[data-swatch-value]');
  if (!choice) return;
  const form = choice.closest('form');
  const select = form.querySelector(`[data-option-index="${choice.dataset.optionIndex}"] [data-variant-select]`);
  if (!select) return;
  select.value = choice.dataset.swatchValue;
  select.dispatchEvent(new Event('change', { bubbles: true }));
});
